import { z } from "zod";

export const lastButtonEventDtoSchema = z.object({
  dateArrival: z.coerce.date(),
  dateMombox: z.coerce.date(),
  modulatorHwId: z.number(),
  momboxHwId: z.number(),
});

export type TLastButtonEventDto = z.infer<typeof lastButtonEventDtoSchema>;
